/**
 * @author ESTECO CSA Team <csa@esteco.com>
 */
const NUMBER_NAMES = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven',
    'Eight', 'Nine', 'Ten'
];

export const getNameFromNumber = (num: number): string => NUMBER_NAMES[num];
